import { useState } from "react";
import { makeRequest } from "../makeRequest";
import { useTranslation } from "react-i18next";

const useGetClearances = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [tries, setTries] = useState(0);

  const retry = () => {
    setTries((prev) => prev + 1);
  };

  const getClearances = async () => {
    setLoading(true);
    setError("");
    let result = [];

    const Params = new URLSearchParams({
      populate: "deep,3",
      "pagination[limit]": -1,
      "filters[Status][$eq]": true,
    });

    // get clearances
    const clearancesBaseUrl = "/clearances";
    const clearancesUrl = `${clearancesBaseUrl}?${Params.toString()}`;

    try {
      setLoading(true);
      result = await makeRequest.get(clearancesUrl);
    } catch (err) {
      setError(t("errors.unknown"));
    }
    setLoading(false);
    setData(result?.data?.data);
  };

  return {
    getClearances,
    data,
    loading,
    error,
    setError,
    retry,
  };
};

export default useGetClearances;